<template>
  <div>
    <ContentBlock style="padding: 10px 10px 84px 10px;">
      <TableWithPagination
        class="special"
        :columnList="columnList"
        :tableData="targetLists"
        :leftToolbar="tableButtons"
        :sortInfo.sync="sortInfo"
        tableBorder="default"
        :showRightToolbar="false"
        :pagination.sync="pagination"
        @size-change="getTargetLists"
        @current-change="getTargetLists"
        @sort-change="getTargetLists"
        :highHoverRow="false"
        :highlightRow="false"
        ref="JZMeasurementUnitTable"
        :checkbox-config="{reserve:true}"
        @selection-change="handleSelectionChange"
      />
    </ContentBlock>
    <EditGoodsUnit ref='JZEditGoodsUnit' @handleReset="handleReset" />
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getGoodsUnitLists, deleteGoodsUnit } from '@/api/PlatformSales/MeasurementUnit';
import EditGoodsUnit from './component/EditGoodsUnit.vue';
export default {
  name: 'PlatformSales_MeasurementUnit',
  components: {
    TableWithPagination,
    EditGoodsUnit,
  },
  mixins: [TablePaginationMixin],
  computed: {
    tableButtons () {
      return [
        {
          name: '添加',
          status: 'primary',
          size: 'small',
          code: 'addBrand',
          permission: '',
          click: this.handleAdd,
        },
        {
          name: '批量删除',
          status: 'default',
          size: 'small',
          code: 'deleteBrand',
          permission: '',
          click: this.handleBatchDelete,
        },
      ];
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '全选',
          width: '100px',
          type: 'checkbox',
        },
        {
          tooltip: true,
          label: '计量单位',
          minWidth: '150px',
          width: '',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '创建时间',
          minWidth: '150px',
          width: '',
          prop: 'createTime',
          sortable: true,
          format: this.$options.filters['date-format'],
        },
        {
          tooltip: true,
          label: '更新时间',
          minWidth: '150px',
          width: '',
          prop: 'lastUpdateTime',
          format: this.$options.filters['date-format'],
        },
        {
          label: '操作',
          prop: 'action',
          width: '140px',
          fixed: 'right',
          render: (h, { row }) => {
            let actions = [];
            actions.push(
              <span class="table-action" onClick={() => this.handleEdit(row)}>
                修改
              </span>);
            actions.push(
              <span class="table-action table-action-delete" onClick={() => this.handleDelete(row)}>
                删除
              </span>);
            return h('div', actions);
          },
        },
      ];
      return cols;
    },
  },
  data () {
    return {
      form: {},
      targetLists: [],
      selectedLists: [],
    };
  },
  methods: {
    handleSelectionChange (currentLists) {
      this.selectedLists = currentLists;
    },
    // 新增品牌
    handleAdd () {
      this.$refs.JZEditGoodsUnit.JZForm = {
        name: '',
      };
      this.$refs.JZEditGoodsUnit.currentId = null;
      this.$refs.JZEditGoodsUnit.dialogTitle = '添加计量单位';
      this.$refs.JZEditGoodsUnit.initPage();
    },
    // 编辑
    handleEdit (row) {
      this.$refs.JZEditGoodsUnit.JZForm = {
        name: row.name,
      };
      this.$refs.JZEditGoodsUnit.currentId = row.id;
      this.$refs.JZEditGoodsUnit.dialogTitle = '编辑计量单位';
      this.$refs.JZEditGoodsUnit.initPage();
    },
    // 删除
    handleDelete (row) {
      this.$confirm(`确认删除计算单位[${row.name}]吗？`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'W400',
      }).then(() => {
        deleteGoodsUnit({ids: [row.id]}).then(() => {
          this.selectedLists = [];
          this.$refs.JZMeasurementUnitTable.clearCheckboxRow();
          this.$message.success('删除成功');
          this.handleSearch();
        });
      });
    },
    handleBatchDelete () {
      if (this.selectedLists.length === 0) {
        this.$message.warning('请至少选择一条数据');
        return;
      }
      const ids = this.selectedLists.map(item => item.id);
      this.$confirm('确认删除选中的计量单位吗？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'W400',
      }).then(() => {
        deleteGoodsUnit({ids}).then(() => {
          this.selectedLists = [];
          this.$refs.JZMeasurementUnitTable.clearCheckboxRow();
          this.$message.success('删除成功');
          this.handleSearch();
        });
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    handleReset () {
      this.form = this.$options.data().form;
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    getTargetLists () {
      const params = {
        ...this.form,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }
      getGoodsUnitLists(params).then(({ body }) => {
        this.targetLists = body?.list || [];
        this.pagination.total = body?.total || 0;
      });
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style scoped lang='scss'>
/deep/ .topTitleContainer {
  height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.title-box {
  color: #303133;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon-box {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;

      &:hover {
        cursor: pointer;
      }
    }

    i {
      &:hover {
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}

/deep/ .el-date-editor.el-input {
  width: -webkit-fill-available;
}
</style>
